import { Booking, DashboardStats, Locker, User } from '../models/domain.models';

export const mockUser: User = {
  id: 1,
  nome: 'Admin VaulTriX',
  email: 'admin@vaultrix.io',
  ruolo: 'admin',
  azienda: 'VaulTriX',
  created_at: new Date().toISOString()
};

export const mockLockers: Locker[] = [
  { id: 1, nome: 'VX Milano Centrale A1', codice: 'VX-MI-CEN-A1', posizione: 'Ingresso binari', citta: 'Milano', indirizzo: 'Piazza Duca d Aosta', stato: 'occupato', partner_id: 2, last_seen: new Date().toISOString(), created_at: new Date().toISOString() },
  { id: 2, nome: 'VX Rimini Beach 04', codice: 'VX-RN-BCH-04', posizione: 'Stabilimento 42', citta: 'Rimini', indirizzo: 'Lungomare Tintori', stato: 'disponibile', partner_id: 2, last_seen: new Date().toISOString(), created_at: new Date().toISOString() },
  { id: 3, nome: 'VX Firenze Museo 02', codice: 'VX-FI-MUS-02', posizione: 'Area deposito', citta: 'Firenze', indirizzo: 'Piazza del Duomo', stato: 'disponibile', partner_id: 2, last_seen: new Date().toISOString(), created_at: new Date().toISOString() },
  { id: 4, nome: 'VX Torino Event 12', codice: 'VX-TO-EVT-12', posizione: 'Padiglione nord', citta: 'Torino', indirizzo: 'Lingotto Fiere', stato: 'manutenzione', partner_id: 2, last_seen: new Date().toISOString(), created_at: new Date().toISOString() },
  { id: 5, nome: 'VX Roma Airport C7', codice: 'VX-RM-FCO-C7', posizione: 'Terminal 3', citta: 'Roma', indirizzo: 'Fiumicino', stato: 'offline', partner_id: 2, last_seen: new Date().toISOString(), created_at: new Date().toISOString() }
];

export const mockBookings: Booking[] = [
  { id: 1, user_id: 1, locker_id: 1, start_time: new Date().toISOString(), end_time: new Date(Date.now() + 7200000).toISOString(), stato: 'active', qr_code: 'VX-DEMO-QR-2026', pin_code: '482913', pagamento_stato: 'paid' },
  { id: 2, user_id: 1, locker_id: 2, start_time: new Date().toISOString(), end_time: new Date(Date.now() + 10800000).toISOString(), stato: 'active', qr_code: 'VX-BEACH-QR-42', pin_code: '193847', pagamento_stato: 'pending' }
];

export const mockStats: DashboardStats = {
  cards: [
    { label: 'Locker totali', value: 248, trend: '+18%' },
    { label: 'Locker attivi', value: 239, trend: '99.2% uptime' },
    { label: 'Locker occupati', value: 137, trend: '+24%' },
    { label: 'Richieste demo', value: 42, trend: '+7 questa settimana' },
    { label: 'Utenti registrati', value: 5840, trend: '+31%' }
  ],
  locker_status: { disponibile: 102, occupato: 137, aperto: 4, manutenzione: 3, offline: 2 },
  daily_usage: [
    { day: '24/05', uses: 42 },
    { day: '25/05', uses: 57 },
    { day: '26/05', uses: 63 },
    { day: '27/05', uses: 72 },
    { day: '28/05', uses: 89 },
    { day: '29/05', uses: 96 },
    { day: '30/05', uses: 112 }
  ],
  ai_insights: [
    'Alta richiesta prevista nella zona stazione',
    '3 locker richiedono manutenzione preventiva',
    'Utilizzo aumentato del 24% questa settimana',
    'Consigliato aggiungere 5 locker nella zona centro'
  ]
};
